import appConfig from "../appconfig";
import VersionProvider from "../providers/VersionProvider";
import LoggerProvider from "../providers/LoggerProvider";
import routeMapper from "../router/routeMapper";
import {get} from "lodash";
import {
	FETCH_AND_CACHE_SHOPS,
	SET_GLOBAL_SELECTED_SHOP_REFRESH_TOKEN,
	UNSET_GLOBAL_SELECTED_SHOP
} from "../store/mutation-types";

const tenantConfig = appConfig.tenantConfig;


export default {
	data() {
		return {
			versionIntervalID: null,
			isPageReady: true
		};
	},
	destroyed() {
		clearInterval(this.versionIntervalID);
	},
	methods: {
		async showPreviousOrders() {
			await this.$store.dispatch("refreshProductCatalog", {
				invalidateCache: true
			});
			this.$router.push({
				name: routeMapper.routeNames.previousOrdersReordering
			});
		},
		initializeGlobalShopRefreshTokenIfNotExistsOrInvalid(){
			if(!this.globalSelectedShopRefreshToken) {
				const globalSelectedShopId = this.globalSelectedShop
					? this.globalSelectedShop.id
					: localStorage.getItem("globalSelectedShopId");
				this.updateRefreshToken(this.tenantSettings.shopRefreshTokens[globalSelectedShopId]);
			}
		},
		validateRefreshToken(selectedShopRefreshToken){
			return selectedShopRefreshToken !== this.globalSelectedShopRefreshToken ? selectedShopRefreshToken : undefined;
		},
		updateRefreshToken(selectedShopRefreshToken){
			this.$store.commit(SET_GLOBAL_SELECTED_SHOP_REFRESH_TOKEN, selectedShopRefreshToken);
		},
		async checkForKioskRefresh(selectedShopRefreshToken){
			this.initializeGlobalShopRefreshTokenIfNotExistsOrInvalid();
			const validatedSelectedShopRefreshToken = this.validateRefreshToken(selectedShopRefreshToken);
			if (validatedSelectedShopRefreshToken) {
				const globalSelectedShopId = this.globalSelectedShop
					? this.globalSelectedShop.id
					: localStorage.getItem("globalSelectedShopId");

				const shops = await this.$store.dispatch(FETCH_AND_CACHE_SHOPS, {
					forceRefresh: true,
					onlyActive: false,
					showSecretRestaurants: true
				});

				const shop = shops.find(s => s.id === globalSelectedShopId);
				if (shop) {
					this.updateRefreshToken(validatedSelectedShopRefreshToken);
					this.$store.commit(UNSET_GLOBAL_SELECTED_SHOP);
					await this.$store.dispatch("setGlobalSelectedShop", shop);
				}
			}
		},
		async establishDeployIntervalPolling() {

			const checkInterval = get(
				this.tenantSettings,
				"deployVersionIntervalTimer",
				null
			);
			if (checkInterval !== null) {
				const shouldRestartKiosk = async () => {
					this.isPageReady = false;
					let shouldRestart = false;
					const globalSelectedShopId = this.globalSelectedShop
						? this.globalSelectedShop.id
						: localStorage.getItem("globalSelectedShopId");

					const {
						data: { version, selectedShopRefreshToken }
					} = await VersionProvider.getVersion(
						tenantConfig.tenantId,
						globalSelectedShopId
					);

					// if sse is disabled, we check for shopRefreshTokens to refresh the kiosk
					// else we rely on sse to refresh the kiosk
					const refreshKioskUsingSse = this.featureToggles.refreshKioskUsingSse === true;
					if (!refreshKioskUsingSse && selectedShopRefreshToken) {
						shouldRestart = selectedShopRefreshToken !== this.globalSelectedShopRefreshToken;
						if (shouldRestart) {
							await this.checkForKioskRefresh(selectedShopRefreshToken);
						}
					}

					if (!version.success) {
						await LoggerProvider.logEvent({
							message: `|VERSION INTERVAL| *Frontend*: Trying to get version failed`,
							eventName: "deployVersionIntervalTimer",
							eventCategory: "",
							eventDomain: "",
							data: version
						});
					}

					if (shouldRestart) {
						location.reload();
					} else {
						this.isPageReady = true;
					}
				};

				await shouldRestartKiosk();
				this.versionIntervalID = setInterval(shouldRestartKiosk, checkInterval);
			} else {
				const message = [];
				if (checkInterval) {
					message.push("Interval is not set up for this tenant");
				}
				if (!appConfig.env.enableReloadInterval) {
					message.push("Version checking is disabled for this environment");
				}
				await LoggerProvider.logEvent({
					message: `|VERSION INTERVAL| *Frontend*: Checking version interval`,
					eventName: "deployVersionIntervalTimer",
					eventCategory: "",
					eventDomain: "",
					data: { message: message.join("\n") }
				});
			}
		}
	}
};
